import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pagination'
})

export class Pagination implements PipeTransform {
    transform(items: any[], page: number): any {
        if(!items){
            return items;
        } 
        return items.filter((item, index) => {
              
            if(index < (page * 20)){
                return true;
            }
        })
    }
    
}


// WEBPACK FOOTER //
// ./src/app/pipes/pagination.pipe.ts